import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { RadialMenu } from './views/RadialMenu';
import { AnimationWrapper } from './views/animate';

const LayoutComponent = () => {
	return (
		<AnimationWrapper>
			<Background />
			<RadialMenu />
		</AnimationWrapper>
	);
};

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.RadialMenu)
	.setHudVisible(true)
	.build();

export default Layout;
